import React, { useState, useEffect } from "react";
import { Menu } from "antd";
import { theme } from "../../styles";
import { PlusOutlined } from "@ant-design/icons";

import { Grid, Tabel, DropDown, Button, Typography, Loading } from "../../core";
import AddSelvedgeModal from "../../components/Modals/Setting/AddSelvedgeModal";
import EditSelvedgeModal from "../../components/Modals/Setting/EditSelvedgeModal";

import DeleteModals from "../../components/Modals/deleteModals";

import {
  getAllSelvedge,
  deleteSelvedge,
} from "../../helper/utils/api/settings";

const { colors } = theme;

const btnProps = {
  width: "130px",
  height: "30px",
  bg: colors.pink,
  margin: "10px 0px 10px auto",
};

const typoProps = {
  align: "center",
  as: "h6",
  weight: "600",
  color: "white",
};
const SelvedgeCompo = () => {
  const [modalState, setModalState] = useState({
    addSelvedgeModal: false,
    editSelvedgeModal: false,
    deleteConfirmModal: false,
  });

  const [isLoading, setIsLoading] = useState(false);

  const [record, setRecord] = useState({
    recordToDelete: {},
    recordToEdit: {},
  });

  const [allSelvedge, setAllSelvedge] = useState([]);

  useEffect(() => {
    getSelvedges();
  }, []);

  const selvedgeDeleteHandler = (record) => {
    setModalState((prev) => ({
      ...prev,
      deleteConfirmModal: true,
    }));
    setRecord({
      recordToDelete: record,
      recordToEdit: {},
    });
  };

  const selvedgeEditHandler = (record) => {
    console.log("record", record);

    setModalState((prev) => ({
      ...prev,
      editSelvedgeModal: true,
    }));
    setRecord({
      recordToDelete: {},
      recordToEdit: record,
    });
  };

  const getSelvedges = async () => {
    let companyId = localStorage.getItem("companyId");
    if (companyId) {
      setIsLoading(true);
      try {
        let {
          data: { result },
        } = await getAllSelvedge({ companyId });

        setAllSelvedge(result);
      } catch (error) {
        console.log("error from get weave", error);
      }
      setIsLoading(false);
    }
  };

  const openModal = (name) => {
    setModalState((prev) => ({
      ...prev,
      [name]: true,
    }));
  };

  const closeModal = (name) => {
    setModalState((prev) => ({
      ...prev,
      [name]: false,
    }));
  };

  const confirmDeleteHandler = async () => {
    if (record.recordToDelete) {
      let { _id } = record.recordToDelete;
      if (_id) {
        setIsLoading(true);
        try {
          await deleteSelvedge(_id);
          closeModal("deleteConfirmModal");
          await getSelvedges();
        } catch (error) {}
        setIsLoading(false);
      }
    }
  };

  const menu = (index, record) => {
    return (
      <Menu>
        <Menu.Item onClick={() => selvedgeDeleteHandler(record)}>
          Delete
        </Menu.Item>
        <Menu.Item onClick={() => selvedgeEditHandler(record)}>Edit</Menu.Item>
      </Menu>
    );
  };

  const columns = [
    {
      title: "SR #",
      dataIndex: "SNo",
      key: "S.No",
      width: 150,
      render: (text, record, index) => <span>{index + 1}</span>,
    },
    {
      title: "Selvedge Value",
      dataIndex: "selvedge",
      key: "selvedge",
      width: 150,
    },
    {
      title: "",
      dataIndex: "action",
      width: 150,
      render: (text, record, index) => (
        <DropDown overlay={() => menu(index, record)}></DropDown>
      ),
    },
  ];

  return (
    <Grid>
      {isLoading ? <Loading /> : null}
      <div>
        <Button {...btnProps} onClick={() => openModal("addSelvedgeModal")}>
          <Typography {...typoProps} noMargin>
            <PlusOutlined />
            Add Selvedge
          </Typography>
        </Button>
      </div>

      <Tabel columns={columns} data={allSelvedge} />

      {modalState.addSelvedgeModal && (
        <AddSelvedgeModal
          addSelvedgeModal={modalState.addSelvedgeModal}
          getSelvedges={getSelvedges}
          closeModal={closeModal}
        />
      )}

      {modalState.deleteConfirmModal && (
        <DeleteModals
          deleteModalsOpen={modalState.deleteConfirmModal}
          closeModal={closeModal}
          confirmDeleteHandler={confirmDeleteHandler}
        />
      )}

      {modalState.editSelvedgeModal && (
        <EditSelvedgeModal
          editSelvedgeModal={modalState.editSelvedgeModal}
          closeModal={closeModal}
          getSelvedges={getSelvedges}
          dataToEdit={record.recordToEdit}
        />
      )}
    </Grid>
  );
};
export default SelvedgeCompo;
